// Iter 124 — shared constants + date helpers used across the roster module.
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fmtDay = (iso) => new Date(iso + 'T00:00:00').toLocaleDateString('en-AU',
  { weekday: 'short', day: 'numeric', month: 'short' });

export const fmtDayLong = (iso) => new Date(iso + 'T00:00:00').toLocaleDateString('en-AU',
  { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });

export const isoDate = (d) => d.toISOString().slice(0, 10);

export const mondayOf = (d) => {
  const x = new Date(d);
  const day = (x.getDay() + 6) % 7;   // Mon=0
  x.setDate(x.getDate() - day);
  x.setHours(0, 0, 0, 0);
  return x;
};

export const addDays = (d, n) => {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
};
